<script setup lang="ts">
const props = defineProps({
  context: Object,
  required: Boolean,
})

// Parse the comma-separated string value
const parseValue = (value: string | undefined) => {
  if (!value) return { min: 0, max: 100 }
  const parts = value.split(',').map(v => parseInt(v.trim()))
  return {
    min: parts[0] ?? 0,
    max: parts[1] ?? 100,
  }
}

// Initialize reactive refs from FormKit context
const initialValue = parseValue(props?.context?.value ?? props?.context?.attrs?.value)
const minValue = ref(initialValue.min)
const maxValue = ref(initialValue.max)

// Watch for external changes from FormKit (when v-model changes externally)
watch(() => props?.context?.value, (newValue) => {
  if (typeof newValue === 'string') {
    const parsed = parseValue(newValue)
    if (parsed.min !== minValue.value) minValue.value = parsed.min
    if (parsed.max !== maxValue.value) maxValue.value = parsed.max
  }
})

const min = computed(() => props?.context?.attrs?.min ?? 0)
const max = computed(() => props?.context?.attrs?.max ?? 100)

// Handle range changes and update FormKit's internal state as comma-separated string
function handleChange(newMin: number, newMax: number) {
  minValue.value = newMin
  maxValue.value = newMax
  props?.context?.node?.input(`${newMin},${newMax}`)
}

watchEffect(() => {
  props?.context?.node?.input(`${minValue.value},${maxValue.value}`)
})
</script>

<template>
  <InputMinMaxRange
    v-model:min-value="minValue"
    v-model:max-value="maxValue"
    :min="min"
    :max="max"
    :push-opposite="props?.context?.attrs?.['push-opposite'] ?? false"
    @change="handleChange"
  />
</template>
